import { handleAttachmentsByPlatform } from './attachments';
import { getDocrioAttachments, usingOfficeApi } from './browser.js';
export const formatToListView = (emails) => Object.entries(emails).filter(([key, value]) => !['AllRecords', 'emails'].includes(key) && value?.length > 0).map(([key, value]) => ({ [key]: value }));

export const processDocrioAndOutlookAttachments = async (getAttachmentsResp, docrioFiles, emailId, subject, docrioNamespace = 'litify_docs') => {
  const { attachments: outlookAttachmentsWithHashes, emlHash, legacyEmlHash } = getAttachmentsResp;
  const attachmentIds = {};
  outlookAttachmentsWithHashes.forEach(({ alternativeHash, hash, id }) => {
    if (attachmentIds[hash]) {
      attachmentIds[hash].push(id);
    } else {
      attachmentIds[hash] = [id];
    }

    if (attachmentIds[alternativeHash]) {
      attachmentIds[alternativeHash].push(id);
    } else {
      attachmentIds[alternativeHash] = [id];
    }
  });

  const hashToFolderPath = {};
  const uniqueDocrioFiles = [];
  docrioFiles.forEach((file) => {
    if (!hashToFolderPath[file?.[`${docrioNamespace}__File_Data_Hash__c`]]) {
      const parsedPath = JSON.parse(file?.[`${docrioNamespace}__File_Info__r.${docrioNamespace}__Folder_Path__c`] || '[]');
      hashToFolderPath[file?.[`${docrioNamespace}__File_Data_Hash__c`]] = {
        [file?.[`${docrioNamespace}__File_Info__r.${docrioNamespace}__Related_To__c`]]: {
          path: parsedPath.join('/'),
          name: parsedPath.length ? parsedPath[parsedPath.length - 1] : (file?.relatedToObjectName ? `${file?.relatedToObjectName} Home` : ''),
          subfolders: [],
        },
      };
      uniqueDocrioFiles.push(file);
    } else {
      const parsedPath = JSON.parse(file?.[`${docrioNamespace}__File_Info__r.${docrioNamespace}__Folder_Path__c`] || '[]');
      hashToFolderPath[file?.[`${docrioNamespace}__File_Data_Hash__c`]][file?.[`${docrioNamespace}__File_Info__r.${docrioNamespace}__Related_To__c`]] = {
        path: parsedPath.join('/'),
        name: parsedPath.length ? parsedPath[parsedPath.length - 1] : (file?.relatedToObjectName ? `${file?.relatedToObjectName} Home` : ''),
        subfolders: [],
      };
    }
  });

  const [emailFile, docrioAttachments] = uniqueDocrioFiles.length ? uniqueDocrioFiles
      .reduce(([eml, attachments], attachment) => {
        const record = {
          id: attachmentIds[attachment?.[`${docrioNamespace}__File_Data_Hash__c`]]?.shift(),
          docrioId: attachment?.[`${docrioNamespace}__File_Info__c`],
          name: attachment?.[`${docrioNamespace}__File_Info__r.Name`],
          folderPaths: hashToFolderPath[attachment?.[`${docrioNamespace}__File_Data_Hash__c`]] || {},
          contentType: attachment?.[`${docrioNamespace}__File_Info__r.${docrioNamespace}__File_Type__c`],
          saved: true,
          hash: attachment?.[`${docrioNamespace}__File_Data_Hash__c`],
        };
        // Check the hashes to see if it matches the calculated eml from
        return (attachment?.[`${docrioNamespace}__File_Data_Hash__c`] === emlHash || attachment?.[`${docrioNamespace}__File_Data_Hash__c`] === legacyEmlHash) ?
          [record, attachments] :
          [eml, [...attachments, record]];
      }, [undefined, []]) : [undefined, []];

  const unsavedAttachments = outlookAttachmentsWithHashes.filter((attachment) => !docrioAttachments.find((docrioAttachment) => {
    return docrioAttachment.hash === attachment.hash || docrioAttachment.hash === attachment.alternativeHash || [];
  }));
  const allAttachments = [
    ...docrioAttachments,
    {
      id: emailId,
      name: emailFile?.name || subject,
      contentType: 'message/rfc822',
      docrioId: emailFile?.docrioId,
      saved: emailFile ? true : false,
      folderPaths: emailFile?.folderPaths || {},
      hash: emailFile?.hash || emlHash,
    },
    ...unsavedAttachments.map((attachment) => ({
      ...attachment,
      folderPaths: {},
      saved: false,
      docrioId: undefined,
    })),
  ];

  return allAttachments;
};

export const processPresavedAndOutlookAttachments = async (outlookAttachmentsWithHashes, draftId, relatedRecords) => {
  const emlFolderPaths = {};
  const hashesToAttachments = {};

  for (const relatedRecord of relatedRecords) {
    const parsedPath = JSON.parse(relatedRecord.attachments?.eml?.Location || '[]');
    emlFolderPaths[relatedRecord.id] = {
      path: parsedPath.join('/'),
      name: parsedPath.length ? parsedPath[parsedPath.length - 1] : (relatedRecord?.relatedToObjectName ? `${relatedRecord?.relatedToObjectName} Home` : ''),
      subfolders: [],
    };

    for (const attachment of [...relatedRecord.attachments.docrioAttachments, ...relatedRecord.attachments.fileAttachments]) {
      if (!hashesToAttachments[attachment.Hash]) {
        const parsedPath = JSON.parse(attachment?.Location || '[]');
        hashesToAttachments[attachment.Hash] = { attachments: [attachment], folderPaths: { [relatedRecord.id]: {
          path: parsedPath.join('/'),
          name: parsedPath.length ? parsedPath[parsedPath.length - 1] : (relatedRecord?.relatedToObjectName ? `${relatedRecord?.relatedToObjectName} Home` : ''),
          subfolders: [],
        } } };
      } else if (hashesToAttachments[attachment.Hash] && Object.keys(hashesToAttachments[attachment.Hash].folderPaths).find((relatedToId) => relatedToId === relatedRecord.id)) { // this is a duplicate attachment on same related record so we want to add it to the attachments array bc we want to allow duplicates
        hashesToAttachments[attachment.Hash].attachments = [...hashesToAttachments[attachment.Hash].attachments, attachment];
      } else {
        const parsedPath = JSON.parse(attachment.Location || '[]');
        hashesToAttachments[attachment.Hash].folderPaths = { ...hashesToAttachments[attachment.Hash]?.folderPaths, [relatedRecord.id]: {
          path: parsedPath.join('/'),
          name: parsedPath.length ? parsedPath[parsedPath.length - 1] : (relatedRecord?.relatedToObjectName ? `${relatedRecord?.relatedToObjectName} Home` : ''),
          subfolders: [],
        } };
      }
    }
  }


  const allSavedAttachments = [];

  for (const outlookAttachment of outlookAttachmentsWithHashes) {
    const attachmentsWithSameHash = hashesToAttachments[outlookAttachment.hash]?.attachments || [];
    if (attachmentsWithSameHash.length) {
      // removes the first element from the array and pushes it to the allSavedAttachments array
      // this is needed to allow duplicate attachments process correctly
      const matchedAttachment = attachmentsWithSameHash.shift();
      allSavedAttachments.push({
        name: matchedAttachment.Name,
        hash: matchedAttachment.Hash,
        folderPaths: hashesToAttachments[matchedAttachment.Hash].folderPaths,
        docrioId: matchedAttachment.Id,
        contentType: outlookAttachment.contentType,
        id: outlookAttachment.id,
        saved: false,
        toSave: false,
        presaved: true,
      });
    }
  }

  const unsavedAttachments = [];
  for (const hash of Object.keys(hashesToAttachments)) {
    const attachmentsWithSameHash = hashesToAttachments[hash].attachments;
    unsavedAttachments.push(...attachmentsWithSameHash);
  }

  const atLeastOneEmlFile = !!relatedRecords.find((record) => Object.keys(record.attachments?.eml || {}).length > 0);
  const emlAttachment = {
    name: relatedRecords[0]?.attachments?.eml.Name || '', // they should all have same name
    folderPaths: emlFolderPaths,
    contentType: 'message/rfc822',
    id: draftId,
    saved: false,
    toSave: false,
    presaved: atLeastOneEmlFile,
    default: !atLeastOneEmlFile,
  };

  const attachments = [
    emlAttachment,
    ...allSavedAttachments,
    ...unsavedAttachments,
  ];

  return attachments;
};

export const getAttachmentsWithCache = async (id, isDraft = false, minumimFileSize, ownerEmail, dispatch) => {
  let attachmentsWithHashes = (await handleAttachmentsByPlatform(id, minumimFileSize, ownerEmail, dispatch, isDraft));
  if (isDraft) {
    const cachedAttachments = await getDocrioAttachments();
    attachmentsWithHashes = attachmentsWithHashes.map((attachment) => {
      if (usingOfficeApi()) {
        const cachedId = cachedAttachments[attachment.hash];
        if (cachedId) {
          attachment['docrioId'] = cachedId;
        }
        return attachment;
      } else {
      // for context see browser.js comment on formatKey()
        const id = attachment.id.replace(/[^a-zA-Z0-9]/g, '');
        const cachedId = cachedAttachments[id];
        if (cachedId) {
          attachment['docrioId'] = cachedId;
        }
        return attachment;
      }
    });
  }
  return attachmentsWithHashes;
};
